<template>
	<!-- Comment -->
	<div class="comment mb-3">
		<div class="row">
			<div class="col-auto">

				<!-- Avatar -->
				<avatar :model="this.comment.commenter" size="sm"/>

			</div>
			<div class="col ms-n2">

				<!-- Body -->
				<div class="comment-body w-100">

					<div class="row align-items-center mb-3">
						<div class="col">

							<h4 class="mb-1">
								{{ this.comment.commenter.name }}
								<span class="fw-normal fs-5 text-muted ms-1">
									{{ formatDate(this.comment.created_at) }}
								</span>
							</h4>

						</div>
						<div v-if="canUpdate" class="col-auto">
							<div class="dropdown">
								<a href="#" class="dropdown-ellipses dropdown-toggle" role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
									<span class="fe fe-more-vertical"></span>
								</a>
								<div class="dropdown-menu dropdown-menu-end">
									<a @click.prevent="editing = true" class="dropdown-item" href="#">
										<span class="fe fe-edit me-2"></span> Edit
									</a>
									<a @click.prevent="destroy" class="dropdown-item" href="#">
										<span class="fe fe-trash me-2"></span> Delete
									</a>
								</div>
							</div>
						</div>
					</div><!--/.row-->

					<!-- Text -->
					<div v-if="editing">
						<div class="mb-3">
							<textarea
								@focus="autosize"
								v-model="body"
								name="body"
								class="form-control form-control-flush"
								data-autosize
								autofocus
								rows="1"></textarea>
						</div>
						<div class="row justify-content-end">
							<div class="col-auto">
								<button class="btn btn-sm btn-link" @click="cancel">Cancel</button>
								<button class="btn btn-sm btn-primary" @click="update">Update</button>
							</div>
						</div>
					</div>
					<div v-else v-html="nl2br(linkify(body))"></div>

				</div>

			</div>
		</div><!--/.row-->
	</div>

</template>

<script>
	import autosize from 'autosize';
	import Avatar from './Avatar.vue';

	import dayjs from 'dayjs';

	export default
	{
		props: ['comment', 'endpoint'],

		emits: ['deleted'],

		components: {
			'avatar': Avatar
		},

		data() {
			return {
				editing: false,
				body: this.comment.body,
			}
		},

		mounted() {

		},

		computed: {

			autosizedTextareas() {
				return document.querySelectorAll('[data-autosize]');
			},

			signedIn() {
				return window.App.signedIn;
			},

			canUpdate() {
				if(typeof window.App == 'undefined') {
					return false;
				}
				return this.comment.commenter.id == window.App.user.id;
			},

		},

		methods: {

			autosize() {
				autosize(this.autosizedTextareas);
				autosize.update(this.autosizedTextareas);
			},

			formatDate(date) {
				return dayjs(date).format('MMM D, YYYY h:mma');
			},

			cancel() {
				this.editing = false;
				this.body = this.comment.body;
			},

			update() {
				axios.patch(this.endpoint + '/' + this.comment.id, {
					body: this.body,
					channel: this.comment.channel
				}).then((response) => {
					console.log(response);
					// flash('Your comment has been updated!');
					this.editing = false;
				})
				.catch((error) => {
					console.error(error);
				});
			},

			destroy() {
				axios.delete(this.endpoint + '/' + this.comment.id)
					.then((response) => {
						console.log(response);
						// this.comments = response.data;
					})
					.catch((error) => {
						console.error(error);
					});

				this.$emit('deleted', this.comment.id);
			},

			nl2br(str, is_xhtml) {
				var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />'   : '<br>';
				return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag   + '$2');
			},

			linkify(text) {
				var urlRegex = /(https?:\/\/[^\s]+)/g;
				return text.replace(urlRegex, function(url) {
					return '<a href="' + url + '" target="_blank" rel="noopener noreferrer">' + url + '</a>';
				});
			}

		}
	};

</script>
